var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Points_icon_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Points_icon_",
    "data-name": "Points icon ",
    clipPath: "url(#clip-Points_icon_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_769",
    "data-name": "Group 769",
    transform: "translate(-660 -645)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_556",
    "data-name": "Ellipse 556",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(660 645)",
    className: "icon-background"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M16.192,3.821a2,2,0,0,1,3.616,0l3.122,6.6a2,2,0,0,0,1.56,1.129l7.262.906A2,2,0,0,1,32.867,15.9l-5.32,4.955a2,2,0,0,0-.6,1.842l1.374,7.128A2,2,0,0,1,25.4,31.962l-6.438-3.52a2,2,0,0,0-1.919,0L10.6,31.962a2,2,0,0,1-2.923-2.133L9.053,22.7a2,2,0,0,0-.6-1.842L3.133,15.9a2,2,0,0,1,1.115-3.448l7.262-.906a2,2,0,0,0,1.56-1.129Z",
    transform: "translate(666 650)",
    className: "icon-foreground"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.397b62b6985462e5d82b393d7c3a7870.svg";
export { ForwardRef as ReactComponent };